import { Group, Text, Divider } from "@mantine/core";
import { ModuleToolBarShell } from "../ModuleToolBarShell";
import { useEnsureRfpDefaultActiveRoomColoringId } from "../useEnsureRfpDefaultActiveRoomColoringId";
import { RFPBarSpecifiedArticlesSection } from "./RFPBarSpecifiedArticlesSection";
import { RFPBarStandardRoomSection } from "./RFPBarStandardRoomSection";

export const RFPBar: React.FC = () => {
  useEnsureRfpDefaultActiveRoomColoringId();

  return (
    <ModuleToolBarShell>
      <Group align="center" gap="md" wrap="nowrap">
        <Group gap="sm" align="center" wrap="nowrap">
          <Text fw={600} size="sm">
            RFP-validering
          </Text>
          <Divider orientation="vertical" h={24} />
          <Text size="sm" c="dimmed">
            Standardrom-valideringer
          </Text>
        </Group>

        <RFPBarStandardRoomSection />

        <RFPBarSpecifiedArticlesSection />
      </Group>
    </ModuleToolBarShell>
  );
};
